import { render, staticRenderFns } from "./UserOrderDetail.vue?vue&type=template&id=e96e448c&scoped=true&"
import script from "./UserOrderDetail.vue?vue&type=script&lang=js&"
export * from "./UserOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserOrderDetail.vue?vue&type=style&index=0&id=e96e448c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96e448c",
  null
  
)

export default component.exports